import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import '../Dashboard.css';

const UpcomingBreaking = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <button 
              onClick={() => navigate('/cubes')}
              style={{
                background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '15px',
                fontWeight: '700',
                transition: 'all 0.3s',
                boxShadow: '0 4px 12px rgba(100, 116, 139, 0.3)'
              }}
            >
              ← رجوع للمكعبات
            </button>
            <h1 style={{ margin: 0 }}>📅 التكسير القادم</h1>
          </div>
        </div>

        <div className="dashboard-main">
          <style>{`
            .upcoming-container {
              padding: 40px 20px;
              max-width: 1200px;
              margin: 0 auto;
            }

            .cards-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
              gap: 30px;
              margin-top: 30px;
            }

            .main-card {
              background: white;
              border-radius: 20px;
              padding: 40px;
              box-shadow: 0 8px 30px rgba(0,0,0,0.12);
              transition: all 0.3s;
              cursor: pointer;
              border: 3px solid transparent;
              text-align: center;
            }

            .main-card:hover {
              transform: translateY(-10px);
              box-shadow: 0 15px 40px rgba(0,0,0,0.2);
            }

            .main-card.tomorrow-card {
              border-color: #f59e0b;
            }

            .main-card.tomorrow-card:hover {
              border-color: #fbbf24;
              background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
            }

            .main-card.week-card {
              border-color: #8b5cf6;
            }

            .main-card.week-card:hover {
              border-color: #a78bfa;
              background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
            }

            .card-icon {
              font-size: 80px;
              margin-bottom: 20px;
              display: block;
            }

            .card-title {
              font-size: 28px;
              font-weight: 800;
              margin: 0 0 15px 0;
              color: #1e293b;
            }

            .card-description {
              font-size: 16px;
              color: #64748b;
              margin: 0;
              line-height: 1.6;
            }

            @media (max-width: 768px) {
              .upcoming-container {
                padding: 20px 15px;
              }

              .cards-grid {
                grid-template-columns: 1fr;
                gap: 20px;
              }

              .main-card {
                padding: 30px;
              }

              .card-icon {
                font-size: 60px;
              }

              .card-title {
                font-size: 22px;
              }

              .card-description {
                font-size: 14px;
              }
            }
          `}</style>

          <div className="upcoming-container">
            <div className="cards-grid">
              {/* كارت تكسير غداً */}
              <div 
                className="main-card tomorrow-card"
                onClick={() => navigate('/cubes/tomorrow-breaking')}
              >
                <span className="card-icon">🌅</span>
                <h2 className="card-title">تكسير غداً</h2>
                <p className="card-description">
                  المكعبات المطلوب تكسيرها غداً مع إشعارات تلقائية
                </p>
              </div>

              {/* كارت تكسير الأسبوع القادم */}
              <div 
                className="main-card week-card"
                onClick={() => navigate('/cubes/next-week')}
              >
                <span className="card-icon">📆</span>
                <h2 className="card-title">تكسير الأسبوع القادم</h2>
                <p className="card-description">
                  جدول المكعبات للسبعة أيام القادمة
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingBreaking;